module.exports = __webpack_public_path__ + "img/undraw_join_re_w1lh.0baf1cb8.svg";